"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2540],{

/***/ 32540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ReviewInputComponent_tsx_UploadReviewFile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/constants/environment.ts
var environment = __webpack_require__(7181);
// EXTERNAL MODULE: ./src/constants/file.ts
var constants_file = __webpack_require__(32336);
// EXTERNAL MODULE: ./src/context/project.context.tsx
var project_context = __webpack_require__(12482);
// EXTERNAL MODULE: ./src/utils/index.ts + 2 modules
var utils = __webpack_require__(67650);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 4 modules
var message = __webpack_require__(2453);
// EXTERNAL MODULE: ./node_modules/antd/es/upload/index.js + 29 modules
var upload = __webpack_require__(45650);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/progress/index.js + 13 modules
var progress = __webpack_require__(38703);
// EXTERNAL MODULE: ./src/components/MeeyImage.tsx
var MeeyImage = __webpack_require__(3524);
;// CONCATENATED MODULE: ./src/components/ReviewInputComponent.tsx/PreviewFile.tsx






// interface PreviewFileProps{
// }
const PreviewFile = (param)=>{
    let { originNode , file , fileList , showPreview =true , loading =false , functionList: { remove , preview , download  }  } = param;
    var _file_name_split, _file_name_split1, _file_name_split2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("relative group cursor-pointer", file.name.match(constants_file/* fileType.image */.r.image) || file.name.match(constants_file/* fileType.video */.r.video) ? "can-preview-upload" : "default-file"),
        onClick: ()=>{
            if (!loading) {
                preview();
            }
        },
        children: [
            file.status !== "done" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-20 h-20 bg-grey-200 rounded-md flex flex-col relative cursor-pointer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-[0_0_36px] w-full flex items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "-rotate-90 w-fit mr-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "mrv mrv-attachment text-fs-20 "
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    ".",
                                    (_file_name_split = file.name.split(".")) === null || _file_name_split === void 0 ? void 0 : _file_name_split.pop()
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-grey-300 flex-[1_1_auto] text-fs-12 py-1.5 px-2 overflow-hidden rounded-md",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "line-clamp-1",
                            children: file.name
                        })
                    })
                ]
            }) : file.name.match(constants_file/* fileType.image */.r.image) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-20 h-20 bg-grey-200 rounded-md flex flex-col relative cursor-pointer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-fs-12 w-full h-full relative overflow-hidden rounded-md",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MeeyImage/* default */.Z, {
                        src: file.thumbUrl,
                        alt: file.name,
                        className: "absolute w-full h-full object-cover",
                        resizeOnFly: false,
                        resizeOptions: {
                            width: 0,
                            height: 0
                        }
                    })
                })
            }) : file.name.match(constants_file/* fileType.video */.r.video) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-20 h-20 bg-grey-200 rounded-md flex flex-col relative cursor-pointer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: " text-fs-12 w-full h-full overflow-hidden rounded-md",
                    children: [
                        file.status === "done" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MeeyImage/* default */.Z, {
                            src: file.thumbUrl,
                            alt: file.name,
                            resizeOnFly: false,
                            resizeOptions: {
                                width: 0,
                                height: 0
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex-[0_0_36px] w-full flex items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "-rotate-90 w-fit mr-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "mrv mrv-attachment text-fs-20 "
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        ".",
                                        (_file_name_split1 = file.name.split(".")) === null || _file_name_split1 === void 0 ? void 0 : _file_name_split1.pop()
                                    ]
                                })
                            ]
                        }),
                        file.status === "done" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "mrv mrv-play_arrow text-white text-fs-24 font-bold"
                            })
                        }) : null
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-20 h-20 bg-grey-200 rounded-md flex flex-col relative cursor-pointer border border-transparent border-dashed",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-[0_0_36px] w-full flex items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "-rotate-90 w-fit mr-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "mrv mrv-attachment text-fs-20 "
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    ".",
                                    (_file_name_split2 = file.name.split(".")) === null || _file_name_split2 === void 0 ? void 0 : _file_name_split2.pop()
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-grey-300 flex-[1_1_auto] text-fs-12 py-1.5 px-2 overflow-hidden rounded-md",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "line-clamp-2",
                            children: file.name
                        })
                    })
                ]
            }),
            file.status === "uploading" || file.status === "done" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute bottom-0 left-0 w-full ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(progress/* default */.Z, {
                    className: "mb-0 mr-0 px-1",
                    percent: file.percent,
                    size: "small",
                    status: file.status === "uploading" ? "active" : file.status === "done" ? "success" : "exception",
                    showInfo: false
                })
            }) : null,
            file.status === "done" && !(0,utils/* isVideoFile */.NU)(file.name) && showPreview ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: ()=>{
                // preview();
                },
                className: "cursor-pointer absolute w-full h-full top-0 z-10 bg-[rgba(0,0,0,0.4)] flex items-center justify-center opacity-0 group-hover:opacity-100 rounded-md duration-300",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "mrv mrv-preview text-white text-fs-20"
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute w-full h-full top-0 z-[15] opacity-0 group-hover:opacity-100 duration-300",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute top-1 right-1 w-6 h-6 border-2 bg-[rgba(0,0,0,0.8)] border-white rounded-full flex items-center justify-center",
                    onClick: (e)=>{
                        if (!loading) {
                            e.stopPropagation();
                            remove();
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "mrv mrv-close text-white text-fs-12 font-bold"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ReviewInputComponent_tsx_PreviewFile = (PreviewFile);

// EXTERNAL MODULE: ./src/constants/common-constant.ts
var common_constant = __webpack_require__(17785);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/ReviewInputComponent.tsx/UploadReviewFile.tsx












const ModalPreviewFile = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(2678), __webpack_require__.e(6205)]).then(__webpack_require__.bind(__webpack_require__, 5523)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(5523)
            ]
    },
    ssr: false
});
message/* default.config */.ZP.config({
    maxCount: 1
});
const UploadReviewFile = (param)=>{
    let { onChange , value , type ="dragger" , setLoading , uploadButtonProps =null , className , showPreview =true , loading =false  } = param;
    const [previewOpen, setPreviewOpen] = (0,react.useState)(false);
    const [previewFile, setPreviewFile] = (0,react.useState)(null);
    const [fileList, setFileList] = (0,react.useState)([]);
    const { refUpload  } = (0,react.useContext)(project_context/* ProjectContext */.x);
    const handleCancel = ()=>setPreviewOpen(false);
    const handlePreview = async (file)=>{
        if (!(0,utils/* isVideoFile */.NU)(file.name)) {
            setPreviewFile(file);
            setPreviewOpen(true);
        }
    };
    (0,react.useEffect)(()=>{
        if (value) setFileList(value === null || value === void 0 ? void 0 : value.map((item)=>({
                uid: item.s3Key,
                ...item,
                status: "done"
            })));
        else setFileList([]);
    }, [
        value
    ]);
    const handleChange = (data)=>{
        const { fileList: files  } = data;
        const hasPendingItem = files.find((i)=>i.status !== "done");
        const newFileList = files.filter((item)=>item.status).map((item)=>{
            var _item_response, _item_response1, _item_response_screenshots, _item_response_screenshots_, _item_response2;
            return {
                ...item,
                thumbUrl: ((_item_response = item.response) === null || _item_response === void 0 ? void 0 : _item_response.url) ? (0,utils/* isImageFile */.CO)(item.name) ? (_item_response1 = item.response) === null || _item_response1 === void 0 ? void 0 : _item_response1.url : (0,utils/* isVideoFile */.NU)(item.name) ? (_item_response_screenshots = item.response.screenshots) === null || _item_response_screenshots === void 0 ? void 0 : (_item_response_screenshots_ = _item_response_screenshots[0]) === null || _item_response_screenshots_ === void 0 ? void 0 : _item_response_screenshots_.url : item.response.url : null,
                s3Key: (_item_response2 = item.response) === null || _item_response2 === void 0 ? void 0 : _item_response2.s3Key
            };
        });
        const removeAnyOldList = fileList.filter((e)=>newFileList.find((item)=>item.uid === e.uid)).map((e)=>{
            const findItem = newFileList.find((item)=>item.uid === e.uid);
            var _findItem_s3Key;
            if (findItem) return {
                ...e,
                s3Key: (_findItem_s3Key = findItem.s3Key) !== null && _findItem_s3Key !== void 0 ? _findItem_s3Key : e.s3Key
            };
            else return e;
        });
        const unionFileList = [
            ...removeAnyOldList
        ];
        // unionBy(newFileList, removeAnyOldList, "uid");
        newFileList.forEach((newItem)=>{
            const existingItemIndex = unionFileList.findIndex((oldItem)=>oldItem.uid === newItem.uid);
            if (existingItemIndex > -1) {
                var _newItem_s3Key, _unionFileList_existingItemIndex_url, _unionFileList_existingItemIndex_thumbUrl;
                unionFileList[existingItemIndex] = {
                    ...newItem,
                    status: newItem.status,
                    s3Key: (_newItem_s3Key = newItem.s3Key) !== null && _newItem_s3Key !== void 0 ? _newItem_s3Key : unionFileList[existingItemIndex].s3Key,
                    url: (_unionFileList_existingItemIndex_url = unionFileList[existingItemIndex].url) !== null && _unionFileList_existingItemIndex_url !== void 0 ? _unionFileList_existingItemIndex_url : newItem.url,
                    thumbUrl: (_unionFileList_existingItemIndex_thumbUrl = unionFileList[existingItemIndex].thumbUrl) !== null && _unionFileList_existingItemIndex_thumbUrl !== void 0 ? _unionFileList_existingItemIndex_thumbUrl : newItem.thumbUrl
                };
            } else unionFileList.push(newItem);
        });
        //
        setFileList(unionFileList);
        if (!hasPendingItem) {
            setLoading(false);
            onChange && onChange(unionFileList);
        } else setLoading(true);
        if ((files === null || files === void 0 ? void 0 : files.length) > common_constant/* MAX_REVIEW_FILE_UPLOAD */.Fr) {
            setLoading(false);
        }
        // console.log(unionFileList);
        const isMatchFileType = files.find((file)=>file.name.match(constants_file/* fileType.file */.r.file) || file.name.match(constants_file/* fileType.image */.r.image) || file.name.match(constants_file/* fileType.video */.r.video));
        if (!isMatchFileType) {
            setLoading(false);
        }
        let totalSize = 0;
        files.forEach((item)=>totalSize += item.size);
        if (totalSize > 1024 * 1024 * 500) {
            setLoading(false);
        }
        const isGT10 = files.find((file)=>file.name.match(constants_file/* fileType.image */.r.image) && file.size > 1024 * 1024 * 10);
        if (isGT10) {
            setLoading(false);
        }
    };
    const uploadButton = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center justify-center",
        id: "btn",
        ref: refUpload,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: "mrv mrv-add_photo_alternate text-blue-400 text-fs-20"
            }),
            !fileList.length && type === "dragger" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-blue-500",
                        children: "Th\xeam ảnh, video, t\xe0i liệu"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-grey-500 text-fs-12",
                        children: "K\xe9o thả hoặc chọn ảnh, video, t\xe0i liệu để th\xeam."
                    })
                ]
            }) : null
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(upload/* default.Dragger */.Z.Dragger, {
                listType: "picture-card",
                className: (0,clsx_m/* default */.Z)("transition-all duration-300", (fileList === null || fileList === void 0 ? void 0 : fileList.length) ? "dragger-hase-file" : type === "upload" ? "!hidden" : "", className),
                // className={clsx(fileList?.length ? "" : "!hidden")}
                fileList: fileList,
                onPreview: showPreview ? handlePreview : null,
                onChange: handleChange,
                accept: ".jpg,.jpeg,.png,.bmp,.heic,.heif,.tiff,.svg,.psd,.webp,.avif,.mp4,.avi,.mkv,.wmv,.vob,.flv,.wmv9,.mpeg,.3gp,.webm,.hevc,.mov,.mpg,.3gpp,.mpeg1,.mpeg2,.mpeg4,.mpegps,.pdf,.xlsx,.xls,.doc,.docx,.pptx,.dwg,.kmz,.wma,.pdf,.xlsx,.xls,.doc,.docx,.pptx",
                multiple: true,
                itemRender: (originNode, file, fileList, param)=>{
                    let { remove , preview , download  } = param;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewInputComponent_tsx_PreviewFile, {
                        originNode: originNode,
                        showPreview: showPreview,
                        file: file,
                        fileList: fileList,
                        functionList: {
                            remove,
                            preview,
                            download
                        },
                        loading: loading
                    });
                },
                showUploadList: (fileList === null || fileList === void 0 ? void 0 : fileList.length) ? {
                    removeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "anticon !text-white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "mrv mrv-close"
                        })
                    })
                } : false,
                beforeUpload: (file, files)=>{
                    let totalSize = 0;
                    fileList.forEach((item)=>totalSize += item.size);
                    return new Promise((resolve, reject)=>{
                        // const isLt2M = file.size / 1024 / 1024 < 10;
                        if (file.name.match(constants_file/* fileType.image */.r.image) && file.size > 1024 * 1024 * 10) {
                            message/* default.error */.ZP.error("Ảnh  dung lượng tối đa 10MB");
                            reject(false);
                        }
                        if (totalSize + file.size > 1024 * 1024 * 500) {
                            reject(false);
                            message/* default.error */.ZP.error("Tổng dung lượng tối đa 500MB");
                        } else if (files.length + (fileList === null || fileList === void 0 ? void 0 : fileList.length) > common_constant/* MAX_REVIEW_FILE_UPLOAD */.Fr) {
                            reject(false);
                            message/* default.error */.ZP.error("Upload tối đa ".concat(common_constant/* MAX_REVIEW_FILE_UPLOAD */.Fr, " files"));
                        } else if (file.name.match(constants_file/* fileType.file */.r.file) || file.name.match(constants_file/* fileType.image */.r.image) || file.name.match(constants_file/* fileType.video */.r.video)) resolve(true);
                        else {
                            reject(false);
                            message/* default.error */.ZP.error("Định dạng kh\xf4ng được hỗ trợ");
                        }
                    });
                },
                customRequest: async (param)=>{
                    let { onSuccess , onError , file , filename , data , onProgress  } = param;
                    const fmData = new FormData();
                    let field = "";
                    if (file.name.match(constants_file/* fileType.image */.r.image)) field = "images";
                    if (file.name.match(constants_file/* fileType.video */.r.video)) field = "videos";
                    if (file.name.match(constants_file/* fileType.file */.r.file)) field = "files";
                    fmData.append(field, file);
                    fmData.append("screenshot", "true");
                    try {
                        var _response_data, _response_data_field;
                        const response = await axios/* default.request */.Z.request({
                            method: "post",
                            baseURL: environment/* API_MEDIA_URL */.lc,
                            url: "v1/media",
                            onUploadProgress: function(progressEvent) {
                                onProgress({
                                    percent: 100 * progressEvent.loaded / progressEvent.total
                                });
                            },
                            headers: {
                                "X-Client-Source": "meeyreview",
                                "Client-ID": "meeyreview"
                            },
                            data: fmData
                        });
                        onSuccess((_response_data = response.data) === null || _response_data === void 0 ? void 0 : (_response_data_field = _response_data[field]) === null || _response_data_field === void 0 ? void 0 : _response_data_field[0]);
                    } catch (err) {
                        onError(err);
                    } finally{}
                },
                disabled: loading,
                children: fileList.length >= 50 ? null : uploadButtonProps || uploadButton
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalPreviewFile, {
                handleCancel: handleCancel,
                previewFile: previewFile,
                previewOpen: previewOpen
            })
        ]
    });
};
/* harmony default export */ var ReviewInputComponent_tsx_UploadReviewFile = (UploadReviewFile);


/***/ })

}]);